import { useQuery } from '@tanstack/react-query';

import { getAgenciesById } from '~/services/AgentHub/AgentService';

const FIVE_MINUTES = 5 * 60 * 1000;

export const agenciesByIdQueryKeys = {
  all: ['agencies-by-id'] as const,
  list: (ids: Array<string>) => [...agenciesByIdQueryKeys.all, ids] as const,
};

export function useGetAgenciesById(ids: Array<string>) {
  return useQuery({
    queryKey: agenciesByIdQueryKeys.list(ids),
    staleTime: FIVE_MINUTES,
    queryFn: async () => {
      if (ids.length === 0) {
        return [];
      }
      return await getAgenciesById(ids);
    },
    enabled: ids.length > 0,
  });
}
